import PlansHelper from 'core-helpers/plans-helper.js';
import FreeTrialService from 'core-services/free-trial/free-trial.service.js';
import FreeTrialUIService from 'free-trial/free-trial-ui-service.js';
import CurrentUser from 'user/current-user-service.js';
import PlansService from 'premium/plans-service.js';
import PurchaseService from 'purchase/purchase-service.js';
import eCommerceService from 'core-services/ecommerce-origin-service.js';
import Utils from 'core-helpers/utils.js';
import ExceptionService from 'core-services/exceptions/exception-service.js';
import { FT_MONTHS, FT_TIER, FT_PLAN_TYPE_REFERRAL } from 'core-services/free-trial/free-trial.constants.js';

/**
 * Private vars
 */
const filename = 'free-trial-banner-controller.js';

/**
 * The full backend response for current user data.
 */
let plans = {};

/**
 * We need a pointer to know which plan has trial
 */
let freeTrialPlan = {
    trial: null
};

const fetchPlans = () => {
    return PlansService.getTieredPlansCustom([FT_PLAN_TYPE_REFERRAL]);
};

const storePlans = (plansData) => {
    plans = Utils.deepClone(plansData);
    return plansData;
};

const onError = (error) => {
    ExceptionService.handle('warning', {
        filename: filename,
        message: 'Tiered plans could not be loaded for free claim trial banner',
        data: error
    });
};

const checkIfUserIsAuthenticated = (plansData) => {
    if (PlansHelper.isUserAuthenticated(plansData)) {
        return CurrentUser.get();
    }
    throw {
        reason: 'USER_NOT_AUTHENTICATED'
    };
};

const checkIfUserIsEligible = (user) => {
    const isEligible = FreeTrialService.isEligibleForReferralFreeTrial(user);
    if (isEligible) {
        return true;
    }
    throw {
        reason: 'USER_NOT_ELIGIBLE'
    };
};

const updateDurationUIFreeTrial = () => {
    FreeTrialUIService.updateTrialDuration(freeTrialPlan.trial.freeTrialDays);
};

const displayBanner = () => {
    FreeTrialUIService.showTrialBanner();
};

const getFreeTrialPlan = () => {
    const trialPlan = PlansHelper.findFreeTrialPlanByMonth(plans[FT_PLAN_TYPE_REFERRAL][FT_TIER], FT_MONTHS);

    if (trialPlan) {
        freeTrialPlan.trial = PlansHelper.getFormattedPlan(trialPlan);
    }
};

const redirect = (URL) => {
    window.location.href = URL;
};

const onTrialSelection = function(e) {

    e.preventDefault();
    FreeTrialUIService.disableBanner();

    const trialPlan = freeTrialPlan.trial;
    const storagePlan = PlansHelper.getValidStoragePlan(plans, trialPlan);

    if (storagePlan.plan.hasFreeTrial) {
        PurchaseService.storePlanForPayment(plans, storagePlan.plan);
        eCommerceService.store('CLAIM_FREE_TRIAL_BANNER');
        redirect(this.href);
    }
};

const updateTrialButtonBehaviour = () => {
    const claimButton = Utils.getElementByClass('js-trial-plan');
    claimButton.addEventListener('click', onTrialSelection);
};

const init = () => {

    fetchPlans()
        .then(storePlans)
        .then(checkIfUserIsAuthenticated)
        .then(checkIfUserIsEligible)
        .then(getFreeTrialPlan)
        .then(updateDurationUIFreeTrial)
        .then(updateTrialButtonBehaviour)
        .then(displayBanner)
        .catch(onError);
};

const FreeTrialInit = {
    init
};

export default FreeTrialInit;
